@if (initialized) {
    <div class="flex justify-content-end p-2 mb-3 surface-0">
    <date-selection-dropdown
            [defaultOption]="'thisMonth'"
            (selectedDateStart)="handlePeriodFilter($event)"
    ></date-selection-dropdown>
    </div>

        <div class="grid dashboard">
            <div class="col-12 md:col-6 mb-2">
                @if (workflowProcessWidget) {
                    <mvs-widget class="surface-0 h-full block shadow-1 m-1"
                            [widgetData]="workflowProcessWidget"
                    ></mvs-widget>
                }
            </div>

            <div class="col-12 md:col-3 mb-2">
                @if (workflowTypeWidget) {
                    <mvs-widget class="surface-0 h-full block shadow-1 m-1"
                            [widgetData]="workflowTypeWidget"
                    ></mvs-widget>
                }
            </div>

            <div class="col-12 md:col-3 mb-2">
                @if (workflowResultWidget) {
                    <mvs-widget class="surface-0 h-full block shadow-1 m-1"
                            [widgetData]="workflowResultWidget"
                    ></mvs-widget>
                }
            </div>

            <!--            <div class="col-12 md:col-4">-->
            <!--                @if (mostUsedWorkflowActivityWidget) {-->
            <!--                    <mvs-widget-->
            <!--                            [widgetData]="mostUsedWorkflowActivityWidget"-->
            <!--                    ></mvs-widget>-->
            <!--                }-->
            <!--            </div>-->

            <div class="col-12 md:col-8 mb-2">
                @if (recentlyAddedWorkflowsWidget) {
                    <mvs-widget class="surface-0 h-full block shadow-1 m-1"
                            [widgetData]="recentlyAddedWorkflowsWidget"
                    ></mvs-widget>
                }
            </div>


            <div class="col-12 md:col-4 mb-2">

                <div class="shadow-1 h-full p-4 surface-0 border-round m-1">
                    <h4 class="text-xl font-medium">Workflow-Übersicht</h4>
                    @if (overviewDto) {
                        <overview [itemsArray]="overviewDto"></overview>
                    }
                </div>
            </div>


        </div>

}